/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Upper_Pink_Beaver_PaveInputs */

const fr_upper_pink_beaver_pave = /** @type {(inputs: Upper_Pink_Beaver_PaveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attribuer des packs`)
};

/**

* @param {Upper_Pink_Beaver_PaveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const upper_pink_beaver_pave = /** @type {((inputs?: Upper_Pink_Beaver_PaveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Upper_Pink_Beaver_PaveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_upper_pink_beaver_pave(inputs)
});